import { render, staticRenderFns } from "./AllTrainingsList.vue?vue&type=template&id=034f9b85"
import script from "./AllTrainingsList.vue?vue&type=script&lang=js"
export * from "./AllTrainingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports